import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var SkeletonTypes;
(function (SkeletonTypes) {
    SkeletonTypes["Title"] = "title";
    SkeletonTypes["Subtitle"] = "subtitle";
    SkeletonTypes["Text"] = "text";
    SkeletonTypes["Input"] = "input";
})(SkeletonTypes || (SkeletonTypes = {}));

const Skeleton = ({ type, lines = 1 }) => {
    const linesQuantityArray = Array.from(Array(lines).keys());
    return (jsxs("section", Object.assign({ className: classNames('pp-skeleton', {
            [`pp-skeleton--${type}`]: type,
        }), "data-testid": "skeleton" }, { children: [jsx("div", Object.assign({ className: "pp-skeleton__shimmer" }, { children: jsx("div", { className: "pp-skeleton__shimmer-blink" }) })), linesQuantityArray.map((item) => (jsx("div", { className: classNames('pp-skeleton__line', {
                    [`pp-skeleton__line--${type}`]: type,
                }), "data-testid": "skeleton-line" }, item)))] })));
};

export { Skeleton, SkeletonTypes };
